var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8132 37.4998L34.584 25.729L31.5631 22.7082L22.7611 31.5103L18.3861 27.1353L15.4173 30.104L22.8132 37.4998ZM12.5007 45.8332C11.3548 45.8332 10.3743 45.4255 9.55898 44.6103C8.74371 43.795 8.33537 42.8137 8.33398 41.6665V8.33317C8.33398 7.18734 8.74232 6.20678 9.55898 5.3915C10.3757 4.57623 11.3562 4.16789 12.5007 4.1665H29.1673L41.6673 16.6665V41.6665C41.6673 42.8123 41.2597 43.7936 40.4444 44.6103C39.6291 45.4269 38.6479 45.8346 37.5007 45.8332H12.5007ZM27.084 18.7498H37.5007L27.084 8.33317V18.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsTask);
export default __webpack_public_path__ + "static/media/material-symbols_task.88b43bf4783dbb69d542f7bde4b0a339.svg";
export { ForwardRef as ReactComponent };